<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="index">
      <label class="question-option">
        <input
          ref="input"
          type="checkbox"
          :value="option.title"
          v-model="val">
        {{ option.title }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    options: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    val: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
